import { useDidUpdate } from "app/custom-hooks/useDidUpdate";
import type { Dispatch, SetStateAction } from "react";
import { useState } from "react";

import type SignalFilters from "../models/core/SignalFilters";

type HookValue<F extends SignalFilters> = {
    currentFilters: Partial<F>;
    setCurrentFilters: Dispatch<SetStateAction<Partial<F>>>;
};

export default function useSignalFiltersState<F extends SignalFilters>(
    filters: Partial<F> | (() => Partial<F>),
    changeHandler?: (filters: Partial<F>) => void,
): HookValue<F> {
    const [currentFilters, setCurrentFilters] = useState(filters);

    useDidUpdate(() => {
        if (typeof changeHandler === "function") {
            setTimeout(() => {
                changeHandler(currentFilters);
            });
        }
    }, [currentFilters]);

    return { currentFilters, setCurrentFilters };
}
